<router-outlet></router-outlet>

<div #contextMenuViewRef>
    <div class="context-menu-origin" #contextMenuOrigin></div>
</div>


// WEBPACK FOOTER //
// /mnt/e/apps/architect3/client/src/app/app.component.html